import {
  PAYROLLCOMPONENTDETAIL_LOADING,
  GET_PAYROLLCOMPONENTDETAIL,
  GET_PAYROLLCOMPONENTDETAIL_SUCCESS,
  GET_PAYROLLCOMPONENTDETAIL_FAIL,
  ADD_PAYROLLCOMPONENTDETAIL_SUCCESS,
  ADD_PAYROLLCOMPONENTDETAIL_FAIL,
  DELETE_PAYROLLCOMPONENTDETAIL_SUCCESS,
  DELETE_PAYROLLCOMPONENTDETAIL_FAIL,
  UPDATE_PAYROLLCOMPONENTDETAIL_SUCCESS,
  UPDATE_PAYROLLCOMPONENTDETAIL_FAIL,
  PAYROLLCOMPONENTDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  payrollComponentDetails: [],
  error: {},
};

const PayrollComponentDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PAYROLLCOMPONENTDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PAYROLLCOMPONENTDETAIL:
          return {
            ...state,
            payrollComponentDetails: action.payload.data,
            isPayrollComponentDetailCreated: false,
            isPayrollComponentDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PAYROLLCOMPONENTDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_PAYROLLCOMPONENTDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPayrollComponentDetailCreated: false,
            isPayrollComponentDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PAYROLLCOMPONENTDETAIL: {
      return {
        ...state,
        isPayrollComponentDetailCreated: false,
        loading: true,
      };
    }

    case PAYROLLCOMPONENTDETAIL_LOADING: {
      return {
        ...state,
        isPayrollComponentDetailCreated: false,
        loading: true,
      };
    }

    case ADD_PAYROLLCOMPONENTDETAIL_SUCCESS:
      return {
        ...state,
        isPayrollComponentDetailCreated: true,
        loading: false,
        payrollComponentDetails: [action.payload.data, ...state.payrollComponentDetails],
      };

    case ADD_PAYROLLCOMPONENTDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PAYROLLCOMPONENTDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isPayrollComponentDetailCreated: true,
        payrollComponentDetails: state.payrollComponentDetails.filter(
          payrollComponentDetail => payrollComponentDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PAYROLLCOMPONENTDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PAYROLLCOMPONENTDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isPayrollComponentDetailCreated: true,
        payrollComponentDetails: state.payrollComponentDetails.map(payrollComponentDetail =>
          payrollComponentDetail.id.toString() === action.payload.data.id.toString() ? { ...payrollComponentDetail, ...action.payload.data } : payrollComponentDetail
        ),
      };

    case UPDATE_PAYROLLCOMPONENTDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PAYROLLCOMPONENTDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PayrollComponentDetail;